import {
  GET_ORGANIZATION_GROUPS_ERROR,
  GET_ORGANIZATION_GROUPS_START,
  GET_ORGANIZATION_GROUPS_SUCCESS,
} from 'constants/action-types/organizations/getGroups';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_ORGANIZATION_GROUPS_START:
      return {
        ...state,
        organizationGroups: {
          ...state.organizationGroups,
          loading: true,
          error: null,
        },
      };
    case GET_ORGANIZATION_GROUPS_SUCCESS:
      return {
        ...state,
        organizationGroups: {
          ...state.organizationGroups,
          loading: false,
          items: payload.data,
          meta: payload.meta,
        },
      };
    case GET_ORGANIZATION_GROUPS_ERROR:
      return {
        ...state,
        organizationGroups: {
          ...state.organizationGroups,
          loading: false,
          error: payload,
        },
      };
    default:
      return null;
  }
};
